import { PropageWindow } from "./PropageWindow";

// Tags that are not rendered by Weasyprint
const WEASYPRINT_TAG_EXCEPTIONS = "div,tbody,tr,thead,colgroup,col,ul,ol,li,pre"

export abstract class WebIframeElement<W extends Window = Window> extends PropageWindow<W> {
  constructor(name: string, window: W) {
    super(name, window, '[id]:not(div)', true);
  }

  async init(): Promise<void> {
    this.window.onload = () => {
      this.add_events();
      console.log(this.name, "initiated.");
    };
  }
  
  jump(id: string): void {
    // Find the corresponding element
    let elements = this.find_id(id);

    if (elements.length > 0 && elements[0]) {
      // And smoothly scroll to it
      elements[0].style.scrollMarginTop = "50px";
      elements[0].scrollIntoView({ behavior: "smooth" });
    }
  }

  find_id(id: string) {
    let elements: HTMLElement[] = [];
    if (id != "content") {
      const elementsOrNull = this.window.document.getElementById(id);
      elements = elementsOrNull ? [elementsOrNull] : [];
    }
    return elements;
  }

  get_id_from_event_target(event_target: HTMLElement): string {
    return event_target.id!;
  }

  highlight(id: string, state: boolean): void {
    // Find the corresponding element
    let elements = this.find_id(id);
    if (elements.length > 0 && elements[0]) {
      elements.forEach(elem => {
        if (elem) { // Condition necessary when everything has not loaded yet
          if (state) {
            this.set_hover_style(elem, false);
          } else {
            this.unset_hover_style(elem);
          }
        }
      });
    }
  }
}
